import { Inject, Injectable } from '@angular/core';
import { ApiModule } from '../api.module';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { Vehicle } from 'src/app/data/model/vehicle';
import { HttpClient } from '@angular/common/http';
import { ENV_CONFIG, EnvironmentConfig } from 'src/app/core/enviroment-config';

@Injectable({
  providedIn: ApiModule,
})
export class VehicleSimpleApi extends CrudApiService<Vehicle> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('resources/simple-vehicle', http, config);
  }
}
